/**
 * The five product sounds (F6), the same wavs the desktop embeds
 * (platform/src/sound.rs): join, leave, mute, unmute as one-shot cues at the
 * desktop's 0.4 volume, ring as the one looping track. Vite fingerprints the
 * files from clients/shared/sounds — one source of truth for both clients
 * (D57).
 */
import joinUrl from "../../../shared/sounds/join.wav";
import leaveUrl from "../../../shared/sounds/leave.wav";
import muteUrl from "../../../shared/sounds/mute.wav";
import unmuteUrl from "../../../shared/sounds/unmute.wav";
import ringUrl from "../../../shared/sounds/ring.wav";

const VOLUME = 0.4;

export type Cue = "join" | "leave" | "mute" | "unmute";

const CUES: Record<Cue, string> = {
  join: joinUrl,
  leave: leaveUrl,
  mute: muteUrl,
  unmute: unmuteUrl,
};

/** Fire-and-forget; autoplay refusals (no gesture yet) are silence, not
 * errors — a sound that cannot play is not worth a notice. */
export function play(cue: Cue): void {
  const el = new Audio(CUES[cue]);
  el.volume = VOLUME;
  void el.play().catch(() => {});
}

let ring: HTMLAudioElement | null = null;

export function ringStart(): void {
  if (ring) return;
  ring = new Audio(ringUrl);
  ring.volume = VOLUME;
  ring.loop = true;
  void ring.play().catch(() => {});
}

export function ringStop(): void {
  ring?.pause();
  ring = null;
}
